const initialState = () => ({
  reports: [],
  isLoading: false,
  hasFetched: false,
  hasError: false,
  // Config pública para el login MSAL de reportes con authMode 'aad'
  aad: { tenantId: null, clientId: null }
})

export default initialState
